import { useEffect } from "react";
import { supabase } from "../lib/supabase";
import { useStore } from "../store/useStore";

export function AuthListener() {
  const setAuth = useStore((state) => state.setAuth);

  useEffect(() => {
    // Fallback: if no session arrives shortly, finish auth init to avoid redirect loop.
    // 5s allows for cold starts and slow devices where reading from local storage takes longer.
    const fallbackTimeout = setTimeout(() => {
      setAuth(null, null);
    }, 5000);

    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      clearTimeout(fallbackTimeout);
      // No stored session means signed out — show the login page right away
      // instead of making signed-out users wait for the fallback timeout.
      setAuth(session?.user ?? null, session ?? null);
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_IN" || (event === "INITIAL_SESSION" && session)) {
        clearTimeout(fallbackTimeout);
        setAuth(session!.user, session!);
        return;
      }

      if (event === "SIGNED_OUT") {
        clearTimeout(fallbackTimeout);
        setAuth(null, null);
        return;
      }

      if (event === "TOKEN_REFRESHED") {
        if (session) {
          setAuth(session.user, session);
        }
        return;
      }

      if (event === "USER_UPDATED") {
        if (session) {
          setAuth(session.user, session);
        }
        return;
      }
    });

    return () => {
      clearTimeout(fallbackTimeout);
      subscription.unsubscribe();
    };
  }, [setAuth]);

  return null;
}
